import React from 'react';

import Avatar from '@mui/material/Avatar';

import { MARKETPLACE_DISPLAY_NAMES } from '@/lib/api';

interface MarketplaceIconProps {
  marketplace: string;
  size?: number;
  className?: string;
}

// Keyed by display name (e.g. "Amazon") since that's what the API returns
// in DisplayOffer.marketplace. Derived from MARKETPLACE_DISPLAY_NAMES to
// stay coupled with the canonical marketplace list.
const MARKETPLACE_ICON_EXTENSIONS: Record<string, string> = {
  Amazon: 'png',
  Walmart: 'png',
  Shopify: 'svg',
};

const MARKETPLACE_ICONS: Record<string, string> = Object.fromEntries(
  Object.values(MARKETPLACE_DISPLAY_NAMES).map((name) => [
    name,
    `/icons/marketplaces/${name.toLowerCase()}.${MARKETPLACE_ICON_EXTENSIONS[name] ?? 'png'}`,
  ])
);

export const MarketplaceIcon: React.FC<MarketplaceIconProps> = ({
  marketplace,
  size = 16,
  className = '',
}) => {
  const iconPath = MARKETPLACE_ICONS[marketplace];

  return (
    <Avatar
      src={iconPath}
      alt={marketplace}
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.75,
        bgcolor: 'transparent',
        color: 'text.primary',
      }}
      variant="square"
      className={className}
      title={marketplace}
    >
      {!iconPath && marketplace.charAt(0)}
    </Avatar>
  );
};
